import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideMobileMenu, restoreMobileMenu } from '@/redux/slices/ui.slice';
import { registerFullscreenView } from '@/shared/utils/nativeBridge';

/**
 * Marca la pantalla actual como vista a pantalla completa. En el navegador
 * oculta el menú de la web; dentro de la app solo REPORTA el hecho y la app
 * decide qué hacer con su menú nativo (regla máxima en `nativeBridge.ts`).
 */
const useHideMobileMenu = (hidden = true) => {
	const dispatch = useDispatch();
	useEffect(() => {
		if (!hidden) return;
		dispatch(hideMobileMenu());
		const unregister = registerFullscreenView();
		return () => {
			dispatch(restoreMobileMenu());
			unregister();
		};
	}, [dispatch, hidden]);
};

export default useHideMobileMenu;
